enum FdmColorEnum {
    ORANGE = 0,
    GREEN = 1,
    BLUE = 2,
    BROWN = 3,
    BLACK = 4,
}

export { FdmColorEnum };
